// 左侧菜单唯一事实源：Layout 渲染 + 路由守卫的"第一个有权限的页面"都从这里取。
// permission 对应后端 ApiPermissionDefinitionProvider 里的定义：
//  - 业务菜单 → Api.AdminMenus.*（纯前端显隐，接口行为权限另行门控）
//  - 用户/角色管理 → AbpIdentity.*（同一权限同时控菜单与 ABP 内置接口）
// 按角色配置入口：系统管理 → 角色管理 → 菜单/权限。

export const menuGroups = [
  {
    index: 'catalog',
    icon: 'el-icon-goods',
    title: '严选目录',
    children: [
      { path: '/products', title: '产品 (AI 推荐池)', permission: 'Api.AdminMenus.Products' },
    ],
  },
  {
    index: 'community',
    icon: 'el-icon-chat-line-square',
    title: '社区运营',
    children: [
      { path: '/community/posts', title: '软文 / 帖子', permission: 'Api.AdminMenus.CommunityPosts' },
      { path: '/community/comments', title: '评论审核', permission: 'Api.AdminMenus.CommunityComments' },
      { path: '/community/treehole', title: '树洞管理', permission: 'Api.AdminMenus.CommunityTreeHole' },
      { path: '/community/categories', title: '频道', permission: 'Api.AdminMenus.CommunityCategories' },
      { path: '/community/featured-cards', title: '专题卡片', permission: 'Api.AdminMenus.CommunityFeaturedCards' },
    ],
  },
  {
    index: 'doctor',
    icon: 'el-icon-first-aid-kit',
    title: '医生工作台',
    children: [
      // 医生（专家）本人登录后台使用：查看自己绑定的患者档案。
      // 数据接口按当前登录人判定专家身份，非专家账号进入会显示引导空态。
      // 有患者消息自己还没看时，菜单右侧出未读总数（医生、医助各算各的）。
      {
        path: '/doctor/my-patients',
        title: '我的患者',
        permission: 'Api.AdminMenus.MyPatients',
        badge: 'patientChatUnread',
      },
      { path: '/doctor/assistants', title: '我的团队', permission: 'Api.AdminMenus.MyAssistants' },
      // 患者申请更换助理 → 专家审批。badge 指明角标数据源（见 Layout.vue），有待审时菜单右侧出红点数字。
      {
        path: '/doctor/assistant-changes',
        title: '医助变更审核',
        permission: 'Api.AdminMenus.AssistantChangeReview',
        badge: 'assistantChangePending',
      },
      // 医生各自维护自己的积分商品；患者在小程序只看得到所绑医生的货架。
      // 医助要替医生维护，需在「我的团队」里开「推品」授权。
      { path: '/doctor/mall', title: '积分商城', permission: 'Api.AdminMenus.DoctorMall' },
      // 医生本人发专家馆文章 / 视频，与小程序「专家发布中心」对等。
      // 与「我的患者」共用医生工作台权限（doctor 角色已有，不用另发后端补权限）；
      // 医助同在 doctor 角色、看得到菜单，但进页面是引导空态——后端也只认认证专家本人发布。
      { path: '/doctor/publish', title: '发布中心', permission: 'Api.AdminMenus.MyPatients' },
      // 医生/医助各自配置聊天话术，命中后自动回复患者（近似匹配，见 views/patients/ChatQa.vue）。
      // 医生自己设计问卷（单选/多选/填空），在患者详情「问卷调查」里推给患者。
      // 与「我的患者」共用医生工作台权限；医助看得到、改不了。
      { path: '/doctor/surveys', title: '问卷管理', permission: 'Api.AdminMenus.MyPatients' },
      { path: '/doctor/chat-qa', title: '自动应答话术', permission: 'Api.AdminMenus.ChatQaRules' },
      // 回访日到了系统替医生先问患者一句（发送日期跟着各患者的回访计划走，
      // 见 views/patients/FollowUpAutoInquiry.vue）。
      {
        path: '/doctor/follow-up-auto-inquiry',
        title: '自动回访话术',
        permission: 'Api.AdminMenus.FollowUpAutoInquiry',
      },
    ],
  },
  {
    index: 'experts',
    icon: 'el-icon-medal',
    title: '专家管理',
    children: [
      { path: '/experts/applications', title: '专家申请审核', permission: 'Api.AdminMenus.ExpertApplications' },
      { path: '/experts/certified', title: '专家列表', permission: 'Api.AdminMenus.ExpertApplications' },
      { path: '/experts/patient-assignment', title: '患者分流', permission: 'Api.AdminMenus.ExpertPatientAssignment' },
      { path: '/experts/contents', title: '专家内容管理', permission: 'Api.AdminMenus.ExpertContents' },
    ],
  },
  {
    index: 'points',
    icon: 'el-icon-coin',
    title: '生命能量积分',
    children: [
      { path: '/points/settings', title: '抵扣率 / 阈值', permission: 'Api.AdminMenus.PointsSettings' },
    ],
  },
  {
    index: 'ai',
    icon: 'el-icon-magic-stick',
    title: 'AI 配置',
    children: [
      { path: '/ai/prompts', title: '提示词维护中心', permission: 'Api.AdminMenus.AiPrompts' },
      { path: '/knowledge-base/documents', title: '知识库', permission: 'Api.AdminMenus.KnowledgeBase' },
    ],
  },
  {
    index: 'metaphysics',
    icon: 'el-icon-moon',
    title: '玄学',
    children: [
      { path: '/metaphysics/tools', title: '工具目录', permission: 'Api.AdminMenus.MetaphysicsTools' },
      { path: '/metaphysics/tarot', title: '塔罗牌库', permission: 'Api.AdminMenus.MetaphysicsTarot' },
      { path: '/metaphysics/oracle-slips', title: '灵签签文', permission: 'Api.AdminMenus.MetaphysicsOracleSlips' },
      { path: '/metaphysics/divination-logs', title: '占卜历史', permission: 'Api.AdminMenus.MetaphysicsDivinationLogs' },
    ],
  },
  {
    path: '/feedback',
    icon: 'el-icon-chat-dot-round',
    title: '用户反馈',
    permission: 'Api.AdminMenus.Feedback',
  },
  {
    index: 'system',
    icon: 'el-icon-setting',
    title: '系统管理',
    children: [
      { path: '/system/users', title: '用户管理', permission: 'AbpIdentity.Users' },
      { path: '/system/roles', title: '角色管理', permission: 'AbpIdentity.Roles' },
      { path: '/system', title: '系统功能管理', permission: 'Api.AdminMenus.SystemSettings' },
    ],
  },
]

// 展平成 [{ path, title, permission }]，顺序即菜单顺序。
export function flatMenuItems() {
  const items = []
  for (const g of menuGroups) {
    if (g.children) items.push(...g.children)
    else items.push(g)
  }
  return items
}

// 给定授权判断函数，返回第一个可见菜单的 path（无权限用户的兜底落点）。
export function firstPermittedPath(can) {
  const hit = flatMenuItems().find((m) => can(m.permission))
  return hit ? hit.path : null
}
